import { COLORS } from '@constants/colors';

export const useStyles = () => ({
  paper: {
    borderRadius: '12px',
    background:
      'linear-gradient(135deg, rgba(35, 38, 47, 0.98) 0%, rgba(18, 18, 22, 0.98) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    backdropFilter: 'blur(12px)',
    color: COLORS.WHITE,
    position: 'relative' as const,
    overflow: 'hidden',
  },
  title: {
    fontWeight: 600,
    color: COLORS.WHITE,
    padding: '18px 20px 14px',
    paddingRight: '56px',
    fontSize: 16,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '0 20px 16px',
  },
  dropZone: {
    border: '1px dashed rgba(255, 255, 255, 0.16)',
    borderRadius: '10px',
    padding: '28px 20px',
    textAlign: 'center' as const,
    backgroundColor: 'rgba(25, 25, 30, 0.55)',
    minHeight: 260,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  dropZoneActive: {
    borderColor: COLORS.MYTAVERSE_BLUE,
    background: 'rgba(69, 84, 229, 0.10)',
  },
  previewZone: {
    padding: 0,
    cursor: 'default',
    overflow: 'hidden',
    borderStyle: 'solid',
    minHeight: 'unset',
    alignItems: 'stretch',
    justifyContent: 'stretch',
  },
  previewFrame: {
    width: '100%',
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.10)',
  },
  dropZoneTitle: {
    color: COLORS.WHITE,
    marginTop: '10px',
    fontSize: 14,
    fontWeight: 500,
  },
  dropZoneSubtitle: {
    color: 'rgba(255, 255, 255, 0.65)',
    marginTop: '6px',
    fontSize: 12,
  },
  uploadIcon: {
    fontSize: 40,
    color: COLORS.MYTAVERSE_BLUE,
  },
  linkButton: {
    marginTop: '8px',
    textTransform: 'none' as const,
    fontWeight: 500,
    fontSize: 12,
    color: COLORS.MYTAVERSE_BLUE,
    padding: 0,
    minHeight: 'auto',
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
  },
  previewImage: {
    width: '100%',
    height: '100%',
    objectFit: 'fill' as const,
    display: 'block',
  },
  statusRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  statusText: {
    color: 'rgba(255, 255, 255, 0.85)',
    fontSize: 13,
  },
  errorText: {
    color: COLORS.RED,
    fontSize: 13,
  },
  closeButton: {
    position: 'absolute' as const,
    top: 12,
    right: 12,
    color: 'rgba(255, 255, 255, 0.65)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },

  requirementsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '10px 4px 0',
    flexWrap: 'wrap' as const,
  },
  requirementsLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    minWidth: 220,
  },
  requirementsText: {
    color: 'rgba(255, 255, 255, 0.60)',
    fontSize: 12,
  },
  requirementsStrong: {
    color: COLORS.WHITE,
    fontWeight: 500,
  },
  copyButton: {
    width: 22,
    height: 22,
    color: 'rgba(255, 255, 255, 0.65)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
    '& .MuiSvgIcon-root': {
      fontSize: 16,
    },
  },

  footer: {
    padding: '12px 20px 16px',
    borderTop: '1px solid rgba(255, 255, 255, 0.08)',
    backgroundColor: 'rgba(0, 0, 0, 0.18)',
  },
  footerSingleButton: {
    width: '100%',
    textTransform: 'none' as const,
    borderRadius: '10px',
    padding: '12px 16px',
    color: COLORS.WHITE,
    borderColor: 'rgba(255, 255, 255, 0.20)',
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.32)',
      backgroundColor: 'rgba(255, 255, 255, 0.10)',
    },
  },
  footerButtons: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap' as const,
  },
  primaryButton: {
    flex: 1,
    minWidth: 160,
    textTransform: 'none' as const,
    borderRadius: '10px',
    padding: '12px 16px',
    fontWeight: 600,
    backgroundColor: COLORS.MYTAVERSE_BLUE,
    '&:hover': {
      backgroundColor: '#3A46C1',
    },
    '&.Mui-disabled': {
      backgroundColor: 'rgba(69, 84, 229, 0.40)',
      color: 'rgba(255, 255, 255, 0.55)',
    },
  },
  secondaryButton: {
    flex: 1,
    minWidth: 160,
    textTransform: 'none' as const,
    borderRadius: '10px',
    padding: '12px 16px',
    color: COLORS.WHITE,
    borderColor: 'rgba(255, 255, 255, 0.20)',
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.32)',
      backgroundColor: 'rgba(255, 255, 255, 0.10)',
    },
  },
  tertiaryButton: {
    flex: 1,
    minWidth: 140,
    textTransform: 'none' as const,
    borderRadius: '10px',
    padding: '12px 16px',
    color: 'rgba(255, 255, 255, 0.90)',
    borderColor: 'rgba(255, 255, 255, 0.18)',
    backgroundColor: 'rgba(255, 255, 255, 0.04)',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.30)',
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },

  // Failure modal
  failurePaper: {
    borderRadius: '12px',
    background:
      'linear-gradient(135deg, rgba(35, 38, 47, 0.98) 0%, rgba(18, 18, 22, 0.98) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    backdropFilter: 'blur(12px)',
    color: COLORS.WHITE,
    position: 'relative' as const,
    overflow: 'hidden',
  },
  failureTitle: {
    fontWeight: 600,
    color: COLORS.WHITE,
    padding: '16px 18px 10px',
    paddingRight: '52px',
    fontSize: 16,
  },
  failureCloseButton: {
    position: 'absolute' as const,
    top: 10,
    right: 10,
    color: 'rgba(255, 255, 255, 0.65)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  failureContent: {
    padding: '0 18px 16px',
  },
  failureText: {
    color: 'rgba(255, 255, 255, 0.75)',
    fontSize: 13,
    lineHeight: 1.4,
  },
  failureDetails: {
    marginTop: '10px',
    color: 'rgba(255, 255, 255, 0.65)',
    fontSize: 12,
  },
  failureActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px',
    marginTop: '14px',
    flexWrap: 'wrap' as const,
  },
  failureMoreInfoButton: {
    textTransform: 'none' as const,
    borderRadius: '10px',
    padding: '8px 14px',
    color: COLORS.WHITE,
    borderColor: 'rgba(255, 255, 255, 0.20)',
    backgroundColor: 'rgba(255, 255, 255, 0.06)',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.32)',
      backgroundColor: 'rgba(255, 255, 255, 0.10)',
    },
  },
  failureTryAgainButton: {
    textTransform: 'none' as const,
    borderRadius: '10px',
    padding: '8px 14px',
    fontWeight: 600,
    backgroundColor: COLORS.MYTAVERSE_BLUE,
    '&:hover': {
      backgroundColor: '#3A46C1',
    },
  },

  // Asset updated confirm
  assetUpdatedPaper: {
    borderRadius: '12px',
    background:
      'linear-gradient(135deg, rgba(35, 38, 47, 0.98) 0%, rgba(18, 18, 22, 0.98) 100%)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    backdropFilter: 'blur(12px)',
    color: COLORS.WHITE,
    position: 'relative' as const,
    overflow: 'hidden',
  },
  assetUpdatedTitle: {
    fontWeight: 600,
    color: COLORS.WHITE,
    padding: '18px 20px 10px',
    paddingRight: '56px',
    fontSize: 18,
  },
  assetUpdatedCloseButton: {
    position: 'absolute' as const,
    top: 12,
    right: 12,
    color: 'rgba(255, 255, 255, 0.65)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
  assetUpdatedContent: {
    padding: '0 20px 18px',
  },
  assetUpdatedText: {
    color: 'rgba(255, 255, 255, 0.75)',
    fontSize: 14,
    lineHeight: 1.4,
    maxWidth: 520,
  },
  assetUpdatedActions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    marginTop: '16px',
  },
  assetUpdatedRevertButton: {
    textTransform: 'none' as const,
    borderRadius: '10px',
    padding: '8px 18px',
    color: COLORS.WHITE,
    borderColor: 'rgba(255, 255, 255, 0.28)',
    '&:hover': {
      borderColor: 'rgba(255, 255, 255, 0.40)',
      backgroundColor: 'rgba(255, 255, 255, 0.04)',
    },
  },
  assetUpdatedSaveButton: {
    textTransform: 'none' as const,
    borderRadius: '10px',
    padding: '8px 18px',
    fontWeight: 600,
    backgroundColor: COLORS.MYTAVERSE_BLUE,
    '&:hover': {
      backgroundColor: '#3A46C1',
    },
  },
});
